<!-- 召回通知单列表 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="400px">
            <creditApplyAction v-if="showStatus" ref="creditApplyAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></creditApplyAction>
        </el-drawer>
        <subComponents ref="showSelectData"></subComponents>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" :buttonFlag="false" :showRefresh="true" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <el-form @submit.native.prevent label-width="100px" :inline="true" size="mini" ref="SEARCH" :model="getRequestData" class="demo-form-inline" :inline-message="false" :show-message="false">
                    <el-form-item label="开始日期" prop="start">
                        <label slot="label" :style="$common.labelStyle('开始日期')" v-html="$common.htmlLabel('开始日期')"></label>
                        <el-date-picker @clear="timeClear('start')" class="form_codition" size="mini" v-model="getRequestData.start" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束日期" prop="end">
                        <label slot="label" :style="$common.labelStyle('结束日期')" v-html="$common.htmlLabel('结束日期')"></label>
                        <el-date-picker @clear="timeClear('end')" class="form_codition" @change="changeTime" size="mini" v-model="getRequestData.end" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date"
                                        placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="单据类型" prop="billtype">
                        <label slot="label" :style="$common.labelStyle('单据类型')" v-html="$common.htmlLabel('单据类型')"></label>
                        <el-select class="form_codition" clearable size="mini" v-model="getRequestData.billType" placeholder="请选择">
                            <el-option label="采购" :value="102"></el-option>
                            <el-option label="销售" :value="201"></el-option>
                            <el-option label="销退" :value="103"></el-option>
                            <el-option label="采退" :value="202"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="单位名称" prop="unitName">
                        <label slot="label" :style="$common.labelStyle('单位名称')" v-html="$common.htmlLabel('单位名称')"></label>
                        <el-input class="form_codition" v-model="getRequestData.unitName" placeholder="请输入单位名称"></el-input>
                    </el-form-item>
                    <el-form-item label="状态" prop="state">
                        <label slot="label" :style="$common.labelStyle('状态')" v-html="$common.htmlLabel('状态')"></label>
                        <el-select class="form_codition" clearable size="mini" v-model="getRequestData.state" placeholder="请选择">
                            <el-option label="重传" :value="0"></el-option>
                            <el-option label="成功" :value="1"></el-option>
                            <el-option label="不处理" :value="2"></el-option>
                            <el-option label="失败" :value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="searchData">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="page_content_center">
            <el-table @sort-change="sortChange" @selection-change="handleSelectionChange" size="mini" :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
                <el-table-column type="selection" width="40" fixed="left"></el-table-column>
                <el-table-column align="center" width="100" label="操作" fixed="left">
                    <template slot-scope="scope">
                        <el-button type="text" style="color: #409eff;" size="mini" @click="handleSee(scope.row)">查看监管码</el-button>
                    </template>
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip min-width="150" prop="billcode" label="上传单号">
                    <template slot-scope="scope">
                        <a @click="toDetail(scope.row.billcode)">{{scope.row.billcode }}</a>
                    </template>
                </el-table-column>
                <el-table-column align="center" sortable="custom" show-overflow-tooltip min-width="120" prop="billtime" label="单据日期">
                    <template slot-scope="scope">
                        <span v-if="scope.row.billtime">
                            {{ $common.getLocalTime(scope.row.billtime) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip min-width="60" prop="billtype" label="单据类型">
                    <template slot-scope="scope">
                        <el-tag size="mini" v-if="scope.row.billtype == 102">采购</el-tag>
                        <el-tag size="mini" v-else-if="scope.row.billtype == 201">销售</el-tag>
                        <el-tag size="mini" v-else-if="scope.row.billtype == 103">销退</el-tag>
                        <el-tag size="mini" v-else-if="scope.row.billtype == 202">采退</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip min-width="120" prop="fromname" label="发货方"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip min-width="120" prop="toname" label="收货方"></el-table-column>
                <!-- <el-table-column align="center" show-overflow-tooltip min-width="120" prop="fromperson" label="销售方联系人"></el-table-column> -->
                <el-table-column align="center" show-overflow-tooltip min-width="120" prop="goname" label="组织名称"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip min-width="60" prop="state" label="状态">
                    <template slot-scope="scope">
                        <el-tag size="mini" type="primary" v-if="scope.row.state == 0">重传</el-tag>
                        <el-tag size="mini" type="success" v-else-if="scope.row.state == 1">成功</el-tag>
                        <el-tag size="mini" type="info" v-else-if="scope.row.state == 2">不处理</el-tag>
                        <el-tag size="mini" type="danger" v-else-if="scope.row.state == 3">失败</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip min-width="300" prop="msginfo" label="失败原因"></el-table-column>

                <!-- <el-table-column align="center" show-overflow-tooltip min-width="120" prop="toperson" label="采购方联系人"></el-table-column> -->
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>

        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" width="800px">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" />
        </el-dialog>
        <el-dialog title="更新单位" v-if="unitShow" :visible.sync="unitShow" width="800px">
            <el-form @submit.native.prevent label-width="100px" :inline="true" size="mini" ref="unitFormData" :model="unitFormData" class="demo-form-inline" :inline-message="false" :show-message="false">
                <el-form-item label="单据编号" prop="billcode">
                    <label slot="label" :style="$common.labelStyle('单据编号')" v-html="$common.htmlLabel('单据编号')"></label>
                    <el-input class="form_codition" v-model="unitFormData.billcode" readonly placeholder="请输入单据编号"></el-input>
                </el-form-item>
                <el-form-item label="单据类型" prop="billtype">
                    <label slot="label" :style="$common.labelStyle('单据类型')" v-html="$common.htmlLabel('单据类型')"></label>
                    <el-select class="form_codition" clearable size="mini" disabled v-model="unitFormData.billtype" placeholder="请选择">
                        <el-option label="采购" value="102"></el-option>
                        <el-option label="销售" value="201"></el-option>
                        <el-option label="销退" value="103"></el-option>
                        <el-option label="采退" value="202"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="平台编号" prop="plCode" :rules="[{ required: true, message: '请输入平台编号', trigger: ['blur','change'] }]">
                    <label slot="label" :style="$common.labelStyle('平台编号')" v-html="$common.htmlLabel('平台编号')"></label>
                    <el-input class="form_codition" v-model="unitFormData.plCode" placeholder="请输入平台编号"></el-input>
                </el-form-item>
                <el-form-item label="平台名称" prop="plName" :rules="[{ required: true, message: '请输入平台名称', trigger: ['blur','change'] }]">
                    <label slot="label" :style="$common.labelStyle('平台名称')" v-html="$common.htmlLabel('平台名称')"></label>
                    <el-input class="form_codition" v-model="unitFormData.plName" placeholder="请输入平台名称"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="unitShow = false">取 消</el-button>
                <el-button type="primary" @click="updateUnit">保 存</el-button>
            </span>
        </el-dialog>
        <el-dialog :title="`查看监管码(${jgmCodeListLength}条)`" v-if="seeShow" :visible.sync="seeShow" width="300px">
            <el-table size="mini" :data="jgmCodeList" height="300" border style="width: 100%" highlight-current-row>
                <el-table-column align="center" show-overflow-tooltip min-width="200" prop="descode" label="监管码"></el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import creditApplyAction from '@/components/creditApplyAction.vue'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        creditApplyAction
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {
                unitName: "",
                billType: "",
                state: "",
                page: 1,
                rows: 30,
                start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],

            pageShowData: [],
            formDataList: [],
            multipleSelection: [],
            showStatus: false,
            actionData: {},

            seId: "",
            dialogTitle: "",
            seWidth: "",
            seTitle: "",
            DialogVisible: false,
            smId: "",
            sField: "",
            parentSearchData: {},
            //-----------------
            unitShow: false,
            unitFormData: {
                billcode: "",
                billtype: "",
                plCode: "",
                plName: "",
            },
            //-----------------
            stateFormData: {
                billcodes: [],
                state: "",
            },
            //-----------
            seeShow: false,
            jgmCodeList: [],
            jgmCodeListLength: 0,

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        sortChange(column) {
            let jurconfigtable=[{
                entityField:column.prop,
            }]
            this.returnData.list = this.$common.sortChange(column, this.returnData.list, jurconfigtable, 'entityField')
        },
        handleSee(row) {
            this.queryJGM(row)
            this.seeShow = true
        },
        queryJGM(row) {
            const params = {
                ids: [row.billcode]
            }
            this.$http.wesMonitorqueryScanCode(params).then(res => {
                console.log(res)
                if (res.status == 200) {
                    this.jgmCodeList = res.result
                    this.jgmCodeListLength = res.result.length
                }
            })
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({  //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: { isPenetrate } //参数
                }, '*');
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        timeClear(val) {
            if (this.getRequestData[val] == null) {
                this.getRequestData[val] = "";
            }
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            if (type == 'salesName') {
                if (this.getRequestData.smId == undefined || this.getRequestData.smId == '') {
                    return this.$message({
                        message: "请先选择单位",
                        type: "error",
                    });
                } else {
                    this.parentSearchData.smId = this.getRequestData.smId
                }
            }
            this.sField = sField;
            this.DialogVisible = true;
            this.seId = sId;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        // 初始化赋值字段值
        initParamValue(setField) {
            let arr = setField.split(',')
            arr.forEach(item => {
                this.$set(this.getRequestData, item, "")
            })
        },
        // 清空赋值字段
        claerValue(field, pField) {
            if (this.getRequestData[field] == '') {
                this.initParamValue(pField)
            }
        },
        // 检索方案带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },

        // 子组件触发
        drawerCancel(e) {
            this.showStatus = false
            if (e == 1) this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
            this.getPageInfo()
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        
        isShowData(name, value) {
            switch (name) {
                case "ovmApper":
                    var dataInfo = JSON.parse(sessionStorage.getItem("selectUserData"));
                    this.getRequestData.ovmApper = dataInfo.opmId;
                    this.getRequestData.opmName = dataInfo.opmName;
                default:
                    this.getRequestData[name] = value;
            }
        },

        // 获取数据列表
        async getPageInfo() {
            var obj = {}
            obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
            for (const key in obj) {
                this.$set(this.getRequestData, key, obj[key])
            }
            this.getButtonList();
            this.getDataList();
        },
        clear(val) {
            if (val) {
                var arr = val.split(",")
                arr.forEach(item => {
                    this.$set(this.getRequestData, item, "")
                })
            }
        },
        // 动作集合
        actionSet(actionData) {
            console.log(actionData.actionType, 'actionData.actionType');

            switch (actionData.actionType) {
                case 1:
                    if (this.returnData.list.length == 0) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    }
                    if (this.multipleSelection.length == 0) {
                        this.$message({
                            message: "请选择数据",
                            type: "error",
                        });
                        return false;
                    }
                    if (this.multipleSelection.some(item => item.state != 3)) {
                        this.$message({
                            message: "请选择失败数据重传",
                            type: "error",
                        });
                        return false;
                    }
                    this.stateFormData.billcodes = this.multipleSelection.map(item => item.billcode)
                    this.stateFormData.state = 0
                    this.updateState()
                    break;
                case 3:
                    if (this.returnData.list.length == 0) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    }
                    if (this.multipleSelection.length == 0) {
                        this.$message({
                            message: "请选择数据",
                            type: "error",
                        });
                        return false;
                    }
                    if (this.multipleSelection.some(item => item.state != 3)) {
                        this.$message({
                            message: "请选择失败数据不处理",
                            type: "error",
                        });
                        return false;
                    }
                    this.stateFormData.billcodes = this.multipleSelection.map(item => item.billcode)
                    this.stateFormData.state = 2
                    this.updateState()
                    break;
                case 2:
                    if (this.returnData.list.length == 0) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    }
                    if (this.multipleSelection.length != 1) {
                        this.$message({
                            message: "请选择一条数据",
                            type: "error",
                        });
                        return false;
                    }
                    var dataInfo = this.multipleSelection[0]
                    if (dataInfo.state != 3) {
                        this.$message({
                            message: "请选择失败数据更新平台名称",
                            type: "error",
                        });
                        return false;
                    }
                    Object.keys(this.unitFormData).forEach(key => {
                        this.unitFormData[key] = dataInfo[key]
                    })
                    if (dataInfo.billtype == 102 || dataInfo.billtype == 103) {
                        this.unitFormData.plName = dataInfo.fromname
                    } else {
                        this.unitFormData.plName = dataInfo.toname
                    }
                    this.unitShow = true;
                    break;

            }
        },
        updateUnit() {
            this.$refs['unitFormData'].validate(async (valid) => {
                if (valid) {
                    const params = {
                        billcode: this.unitFormData.billcode,
                        billtype: this.unitFormData.billtype,
                        plCode: this.unitFormData.plCode,
                        plName: this.unitFormData.plName,
                    }
                    const res = await this.$http.wesMonitorupdatePlname(params)
                    if (res.status == 200) {
                        this.$message({
                            message: res.message,
                            type: "success",
                        });
                        this.unitShow = false;
                        this.getDataList();
                    } else {
                        this.$message({
                            message: res.message,
                            type: "error",
                        });
                    }
                } else {
                    this.$message({
                        message: "请填写完整信息",
                        type: "error",
                    });
                }
            })
        },
        async updateState() {
            const res = await this.$http.wesMonitorupdateState(this.stateFormData)
            if (res.status == 200) {
                this.$message({
                    message: res.message,
                    type: "success",
                });
                this.stateShow = false;
                this.getDataList();
            } else {
                this.$message({
                    message: res.message,
                    type: "error",
                });
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.wesMonitorqueryList(this.getRequestData);
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.total = responseData.result.total;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 删除数据
        delDataAction() {
            if (this.returnData.list.length <= 0) {
                this.$message({
                    message: '暂无数据',
                    type: 'error'
                });
                return
            }
            var dataInfo = this.returnData.list[this.selectDataIndex]
            if (!dataInfo) {
                this.$message({
                    message: '请选择数据',
                    type: 'error'
                });
                return
            }
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    let responseData = await this.$http.creditApplydeleteCreditApply({ ids: dataInfo.id });
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}
.form_codition {
    width: 220px;
}
</style>